var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Login"},[_c('mynav',{staticClass:"nav"}),_c('div',{staticClass:"loginmain"},[_c('div',{staticClass:"bglogo"}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }